import React, { useEffect, useState } from 'react';
import {
  InputSelect,
  IputDateMaterialUI,
  InputNumber
} from '../../components/inputs';
import { API_HOST } from '../../consts';
import Axios from 'axios';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
// import InputDate from '../../components/inputs/InputDate';
import {
  ButtonCancelar,
  ButtonSubmit,
  DivBody,
  DivButton,
  DivConteiner,
  DivFather,
  DivHeaderForm,
  DivSelectForm,
  FormContainer,
  SpanTitle
} from './styles/ReviewAplicationRedacaoStyles';
import { toast } from 'react-toastify';

const ReviewAplicationRedacao = () => {
  const [formValues, setFormValues] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [escola, setEscola] = useState();
  const [ano, setAno] = useState();
  const [periodo, setPeriodo] = useState();
  const [periodoAno, setPeriodoAno] = useState();
  const [etapaId, setEtapaId] = useState();
  const [etapaOption, setEtapaOption] = useState();
  const [turmaOptions, setTurmaOptions] = useState();
  const [regional, setRegional] = useState();
  const [tema, setTema] = useState([]);

  const fetchRegional = async () => {
    try {
      const res = await Axios.get(`${API_HOST}/avalia/dre`);
      setRegional(
        res.data.map((x) => ({
          value: x.id,
          label: x.dre_name,
          ...x
        }))
      );
    } catch (err) {
      console.error(err);
    }
  };

  const fetchEscola = async () => {
    setEscola();
    if (formValues.values.regionalOptions) {
      try {
        const params = {
          dre: formValues.values.regionalOptions
        };
        const res = await Axios.get(`${API_HOST}/avalia/escola`, { params });
        setEscola(
          res.data.map((x) => ({
            value: x.cd_escola,
            label: x.nm_escola,
            ...x
          }))
        );
      } catch (err) {
        console.error(err);
      }
    }
  };

  const fetchEtapaEscola = async () => {
    if (formValues.values.escolaOptions) {
      try {
        const res = await Axios.get(
          `${API_HOST}/avalia/escola_etapa?cd_escola=${formValues.values.escolaOptions}`
        );
        setEtapaOption(
          res.data.results.map((x) => ({
            value: x.cd_etapa,
            idn: x.idn,
            label: x.dc_etapa,
            etapa_id: x.etapa_id,
            ...x
          }))
        );
      } catch (err) {
        console.error(err);
      }
    }
  };
  console.log(etapaOption);

  const fetchTurma = async () => {
    if (formValues.values.escolaOptions) {
      try {
        const res = await Axios.get(
          `${API_HOST}/avalia/turma?cd_escola=${formValues.values.escolaOptions}&cd_etapa=${formValues.values.etapaOption}&periodo_ano_id=${periodoAno.periodoAno}`
        );
        setTurmaOptions(
          res.data.results.map((x) => ({
            value: x.cd_turma,
            label: '(' + x.nm_turma + ') ' + x.cd_turma,
            ...x
          }))
        );
      } catch (err) {
        console.error(err);
      }
    }
  };

  const postPedido = async () => {
    if (
      formValues.values.regionalOptions == null ||
      formValues.values.escolaOptions == null ||
      formValues.values.etapaOption == null ||
      formValues.values.turmaOptions == null ||
      formValues.values.startTime == null ||
      endTime == null ||
      etapaId == null ||
      formValues.values.duration == null ||
      formValues.values.examType == null ||
      periodoAno.periodoAno == null
    ) {
      toast.error('Selecione os campos antes de solicitar o agendamento');
    } else {
      try {
        const params = {
          tema: tema.id,
          dre_id: regional
            .filter((x) => x.id == formValues.values.regionalOptions)
            .map((x) => x.id)[0],
          dre_nome: regional
            .filter((x) => x.id == formValues.values.regionalOptions)
            .map((x) => x.dre_name)[0],
          escola_id: parseInt(
            escola
              .filter((x) => x.cd_escola == formValues.values.escolaOptions)
              .map((x) => x.cd_escola)[0]
          ),
          escola_nome: escola
            .filter((x) => x.cd_escola == formValues.values.escolaOptions)
            .map((x) => x.nm_escola)[0],
          etapa_id: parseInt(
            etapaOption
              .filter((x) => x.cd_etapa == formValues.values.etapaOption)
              .map((x) => x.cd_etapa)[0]
          ),
          etapa_nome: etapaOption
            .filter((x) => x.cd_etapa == formValues.values.etapaOption)
            .map((x) => x.dc_etapa)[0],
          turma_id: parseInt(
            turmaOptions
              .filter((x) => x.cd_turma == formValues.values.turmaOptions)
              .map((x) => x.cd_turma)[0]
          ),
          turma_nome: turmaOptions
            .filter((x) => x.cd_turma == formValues.values.turmaOptions)
            .map((x) => '(' + x.nm_turma + ') ' + x.cd_turma)[0],
          start_time: formValues.values.startTime,
          end_time: endTime,
          duration: formValues.values.duration,
          exam_type: formValues.values.examType,
          etapa_id: etapaId,
          periodo_ano_id: periodoAno.periodoAno
        };
        await Axios.post(`${API_HOST}/redacao_temas/pedidos`, params);
        window.location.href = `/redacao/temas-redacoes`;
      } catch (err) {
        toast.error(
          'Não foi possível solicitar o agendamento. Tente novamente'
        );
        console.error(err);
      }
    }
  };

  const fetchTema = async (id) => {
    if (id) {
      try {
        const res = await Axios.get(`${API_HOST}/redacao_temas/temas/${id}`);
        setTema(res.data);
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    const url = window.location.pathname.split('/');
    const id = url[url.length - 1];
    fetchRegional();
    fetchTema(id);
  }, []);

  const handleSubmit = async () => {
    postPedido();
  };

  const handleCancel = async () => {
    window.location.href = `/redacao/temas-redacoes`;
  };

  const optionsInput = [
    {
      value: '2',
      label: 'Impressa Presencial'
    },
    {
      value: '3',
      label: 'Online Presencial'
    }
  ];

  const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
  };

  const formatDate = (date) => {
    return (
      [
        date.getFullYear(),
        padTo2Digits(date.getMonth() + 1),
        padTo2Digits(date.getDate())
      ].join('-') +
      ' ' +
      [
        padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
        padTo2Digits(date.getSeconds())
      ].join(':')
    );
  };

  const handleSetEndTime = (duration) => {
    const startTime = formValues.values.startTime;
    if (!startTime) return;

    const currentDate = new Date(startTime);
    currentDate.setMinutes(currentDate.getMinutes() + parseInt(duration));

    setEndTime(formatDate(currentDate));
  };

  const fetchAno = () => {
    Axios.get(`${API_HOST}/avalia/ano`)
      .then((res) => {
        const data = res.data.map((d) => ({
          value: d.id,
          label: d.ds_ano
        }));
        setAno(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchPeriodo = () => {
    Axios.get(`${API_HOST}/avalia/periodo`)
      .then((res) => {
        const data = res.data.map((d) => ({
          value: d.id,
          label: d.ds_periodo
        }));

        setPeriodo(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const fetchAnoPeriodo = async (e) => {
    try {
      const response = await Axios.get(
        `${API_HOST}/avalia/periodo_ano?periodo__id=${e.value}&ano__id=${formValues.values.year}`
      );
      if (response.data.length > 0) {
        setPeriodoAno({
          periodoAno: response.data[0].id,
          ano: ano
        });
        fetchEscola();
      } else {
        toast.error('Nenhum período de avaliação encontrado');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    tema.length !== 0 && (
      <DivFather>
        <DivConteiner>
          <NavBreadCrumb currentPath={tema.nome} hasBackslash={false} />
          <FormContainer onChange={(formState) => setFormValues(formState)}>
            <DivHeaderForm>
              <SpanTitle>Selecione a turma e escola para agendamento</SpanTitle>
              <DivSelectForm>
                <InputSelect
                  key={regional}
                  label="DRE"
                  col="col-md-2"
                  field="regionalOptions"
                  // onChange={() => fetchEscola()}
                  onChange={() => fetchAno()}
                  options={regional}
                />
                <InputSelect
                  key={ano}
                  label="Ano"
                  col="col-md-2"
                  field="year"
                  onChange={() => fetchPeriodo()}
                  options={ano}
                />
                <InputSelect
                  key={periodo}
                  label="Avaliação"
                  col="col-md-2"
                  field="period"
                  onChange={(e) => fetchAnoPeriodo(e)}
                  options={periodo}
                />
                <InputSelect
                  key={escola}
                  label="Escolas"
                  col="col-md-4"
                  field="escolaOptions"
                  options={escola}
                  onChange={() => fetchEtapaEscola()}
                />
                <InputSelect
                  key={etapaOption}
                  label="Etapa"
                  col="col-md-2"
                  field="etapaOption"
                  options={etapaOption}
                  onChange={(e) => {
                    fetchTurma();
                    if (e.etapa_id) {
                      setEtapaId(e.etapa_id);
                    }
                  }}
                />
              </DivSelectForm>

              <DivSelectForm>
                {/* <InputSelect
                  key={etapaOption}
                  label="Etapa"
                  col="col-md-2"
                  field="etapaOption"
                  options={etapaOption}
                  onChange={(e) => {
                    fetchTurma();
                    if (e.etapa_id) {
                      setEtapaId(e.etapa_id);
                    }
                  }}
                /> */}
                <InputSelect
                  key={turmaOptions}
                  label="Turmas"
                  col="col-md-3"
                  field="turmaOptions"
                  options={turmaOptions}
                />
                <IputDateMaterialUI
                  label="Data/Hora de Início"
                  col="col-md-3"
                  field="startTime"
                  onChange={(e) => {
                    setEndTime(e);
                  }}
                />
                <InputNumber
                  label="Duração da prova (em minutos)"
                  field="duration"
                  col="col-md-3"
                  onChange={(e) => handleSetEndTime(e)}
                />
                <IputDateMaterialUI
                  label="Data/Hora de Fim"
                  col="col-md-3"
                  field="endTime"
                  value={endTime}
                  disabled
                />
              </DivSelectForm>
              <InputSelect
                label="Formato de Aplicação"
                col="col-md-2"
                field="examType"
                options={optionsInput}
              />
              <DivSelectForm></DivSelectForm>
            </DivHeaderForm>
            <DivBody>
              <DivButton>
                <ButtonCancelar onClick={(e) => handleCancel(e)}>
                  Cancelar
                </ButtonCancelar>
                <ButtonSubmit onClick={(e) => handleSubmit(e)}>
                  Solicitar agendamento
                </ButtonSubmit>
              </DivButton>
            </DivBody>
          </FormContainer>
        </DivConteiner>
      </DivFather>
    )
  );
};

export default ReviewAplicationRedacao;
